export default __webpack_public_path__ + "static/media/portatambor.9690d50d.png";